export default __webpack_public_path__ + "static/media/Category-18.412d8039.jpg";